<template>
  <RevDialog :name="modalName" :title="i18n(translations.title)">
    <template #body>
      <p class="body-1 px-72 pb-24 pt-32 text-center">
        {{ i18n(translations.body) }}
      </p>
    </template>

    <template #footer="{ close }">
      <div class="flex flex-col items-center">
        <RevButton
          full-width="always"
          variant="primary"
          @click="handleDeleteAddress(close)"
        >
          {{ i18n(translations.confirmation) }}
        </RevButton>

        <div class="flex justify-center py-24">
          <RevLink @click="close">
            {{ i18n(translations.cancel) }}
          </RevLink>
        </div>
      </div>
    </template>

    <template #trigger="{ open }">
      <slot v-bind="{ open }" name="trigger" />
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { HttpApiError, merchantsAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { RevLink } from '@ds/components/Link'

import { MODAL_NAMES } from '../../AddressesManager.constants'

import translations from './DeleteAddressModal.translations'

const props = defineProps<{
  addressId: string | number
}>()

const emit = defineEmits(['address-deleted'])

const i18n = useI18n()
const { openErrorToast } = useTheToast()
const modalName = computed(
  () => `${MODAL_NAMES.DELETE}-${props.addressId.toString()}`,
)

async function handleDeleteAddress(close: () => void) {
  try {
    await $httpFetch(merchantsAPI.deleteAddress, {
      pathParams: { id: props.addressId },
    })
    emit('address-deleted')
  } catch (error) {
    const { title: content } = HttpApiError.fromAnyError(error as Error)

    openErrorToast({ content })
  } finally {
    close()
  }
}
</script>
